function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#6A64F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8166 15.2892L36.0916 26.563L28.383 31.9108L20.5299 26.5148L27.7568 15.2892C27.9976 14.9038 28.5758 14.9038 28.8166 15.2892Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8649 40.0048L36.5734 28.0083C36.5844 27.9863 36.5929 27.9643 36.6011 27.943C36.6138 27.91 36.6261 27.8783 36.6462 27.8501L28.8649 33.2116C28.8346 33.2217 28.8066 33.2317 28.7797 33.2413L28.779 33.2415C28.6776 33.2779 28.5936 33.308 28.4795 33.308C28.3349 33.308 28.1904 33.308 28.0939 33.2116L20 27.6229C20 27.7674 20 27.912 20.0963 28.0083L27.8049 40.0048C27.9013 40.1974 28.0939 40.2939 28.3349 40.2939C28.5276 40.2939 28.7684 40.1974 28.8649 40.0048Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 47,
  r: 8,
  fill: "#716BF4",
  stroke: "white",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49 45L47 48L45 45H43L47 51L51 45H49Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 9.5,
  y1: 7,
  x2: 45.5,
  y2: 49.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8680F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6A64F3"
})));

function SvgCoinIconVeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconVeth);
export default __webpack_public_path__ + "static/media/CoinIconVETH.73108645.svg";
export { ForwardRef as ReactComponent };